import { useEffect } from "react";

/**
 * useInvestorShortcuts — Welle 5 Speed-Qualifizierung
 * Registriert globale Keyboard-Handler nur wenn `enabled = true` und kein Textfeld fokussiert ist.
 *
 * Shortcuts:
 *   J          → focusNext()
 *   K          → focusPrev()
 *   → / Enter  → advance current
 *   ←          → regress current
 *   X, Delete  → disqualify current
 *   Space, D   → open drawer
 *   Shift+P    → pin_up
 *   Shift+O    → pin_down
 *   ?          → show shortcut overlay
 *   Esc        → close overlay (extern behandelt)
 */
export function useInvestorShortcuts({
  enabled,
  onFocusNext,
  onFocusPrev,
  onAdvance,
  onRegress,
  onDisqualify,
  onOpenDrawer,
  onPinUp,
  onPinDown,
  onShowHelp,
}) {
  useEffect(() => {
    if (!enabled) return undefined;

    const handler = (e) => {
      const tag = (e.target?.tagName || "").toLowerCase();
      const isFormElement = tag === "input" || tag === "textarea" || tag === "select" || e.target?.isContentEditable;
      if (isFormElement) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      const key = e.key;
      switch (key) {
        case "j":
        case "J":
          e.preventDefault(); onFocusNext?.(); break;
        case "k":
        case "K":
          e.preventDefault(); onFocusPrev?.(); break;
        case "ArrowRight":
        case "Enter":
          e.preventDefault(); onAdvance?.(); break;
        case "ArrowLeft":
          e.preventDefault(); onRegress?.(); break;
        case "x":
        case "X":
        case "Delete":
          e.preventDefault(); onDisqualify?.(); break;
        case " ":
        case "d":
        case "D":
          e.preventDefault(); onOpenDrawer?.(); break;
        case "P":
          if (e.shiftKey) { e.preventDefault(); onPinUp?.(); }
          break;
        case "O":
          if (e.shiftKey) { e.preventDefault(); onPinDown?.(); }
          break;
        case "?":
          e.preventDefault(); onShowHelp?.(); break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [enabled, onFocusNext, onFocusPrev, onAdvance, onRegress, onDisqualify, onOpenDrawer, onPinUp, onPinDown, onShowHelp]);
}
